// eslint-disable-next-line import/prefer-default-export
export const isObjectValidAndNotEmpty = anObject => (
    anObject && typeof anObject === 'object' && Object.keys(anObject).length > 0
);
